/* Find Us store locator — Leaflet map + store list.
   Coordinates resolve in order: explicit "coords" field → lat/lng embedded in
   the Google Maps link → Nominatim geocode of the address (cached, 1 req/s). */
(function () {
  var mapEl = document.querySelector('[data-locator-map]');
  var dataEl = document.querySelector('[data-locator-stores]');
  if (!mapEl || !dataEl || typeof L === 'undefined') return;

  var stores;
  try {
    stores = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  if (!stores.length) return;

  var map = L.map(mapEl, { scrollWheelZoom: false, tap: false });
  L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
    maxZoom: 19,
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  }).addTo(map);
  map.setView([37.33, -122.03], 9);

  var pinIcon = L.divIcon({
    className: 'locator__pin',
    html:
      '<svg width="34" height="44" viewBox="0 0 34 44" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M17 1C8.2 1 1 8.1 1 16.9 1 28.8 17 43 17 43s16-14.2 16-26.1C33 8.1 25.8 1 17 1z" fill="#A83562" stroke="#F2EFDD" stroke-width="2"/>' +
      '<circle cx="17" cy="16.5" r="5.5" fill="#F2EFDD"/></svg>',
    iconSize: [34, 44],
    iconAnchor: [17, 43],
    popupAnchor: [0, -40]
  });

  function parseCoords(str) {
    if (!str) return null;
    var m = String(str).match(/(-?\d{1,3}(?:\.\d+)?)[,\s]+(-?\d{1,3}(?:\.\d+)?)/);
    if (!m) return null;
    var lat = parseFloat(m[1]);
    var lng = parseFloat(m[2]);
    if (isNaN(lat) || isNaN(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180) return null;
    return [lat, lng];
  }

  function coordsFromMapsUrl(url) {
    if (!url) return null;
    var m = url.match(/@(-?\d{1,3}\.\d+),(-?\d{1,3}\.\d+)/);
    if (!m) m = url.match(/!3d(-?\d{1,3}\.\d+)!4d(-?\d{1,3}\.\d+)/);
    if (!m) m = url.match(/[?&]query=(-?\d{1,3}\.\d+)(?:,|%2C)(-?\d{1,3}\.\d+)/);
    return m ? parseCoords(m[1] + ',' + m[2]) : null;
  }

  var GEO_CACHE_KEY = 'auma-locator-geocode';
  var geoCache = {};
  try {
    geoCache = JSON.parse(localStorage.getItem(GEO_CACHE_KEY)) || {};
  } catch (e) {}

  function saveGeoCache() {
    try {
      localStorage.setItem(GEO_CACHE_KEY, JSON.stringify(geoCache));
    } catch (e) {}
  }

  var geocodeQueue = Promise.resolve();
  function geocode(address) {
    if (!address) return Promise.resolve(null);
    if (geoCache[address]) return Promise.resolve(geoCache[address]);
    // Nominatim asks for max 1 request/second — chain requests sequentially.
    geocodeQueue = geocodeQueue.then(function () {
      if (geoCache[address]) return geoCache[address];
      var url =
        'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' +
        encodeURIComponent(address);
      return fetch(url)
        .then(function (r) { return r.json(); })
        .then(function (results) {
          var hit = results && results[0];
          var coords = hit ? [parseFloat(hit.lat), parseFloat(hit.lon)] : null;
          if (coords) {
            geoCache[address] = coords;
            saveGeoCache();
          }
          return coords;
        })
        .catch(function () { return null; })
        .then(function (coords) {
          // Pace the queue even after a failed request.
          return new Promise(function (resolve) {
            setTimeout(function () { resolve(coords); }, 1100);
          });
        });
    });
    return geocodeQueue;
  }

  var cards = document.querySelectorAll('[data-locator-card]');
  var markers = {};
  var placed = [];

  function fitAll() {
    if (!placed.length) return;
    if (placed.length === 1) {
      map.setView(placed[0].getLatLng(), 13);
    } else {
      map.fitBounds(L.featureGroup(placed).getBounds(), { padding: [48, 48] });
    }
  }

  function addMarker(store, index, coords) {
    var marker = L.marker(coords, { icon: pinIcon }).addTo(map);
    var directions = /^https?:\/\//i.test(store.mapsUrl || '')
      ? '<br><a href="' + escapeAttr(store.mapsUrl) + '" target="_blank" rel="noopener">Get directions</a>'
      : '';
    marker.bindPopup(
      '<strong>' + escapeHtml(store.name) + '</strong><br>' +
      escapeHtml(store.address || '') + directions
    );
    marker.on('click', function () { highlight(index); });
    markers[index] = marker;
    placed.push(marker);
    fitAll();
  }

  function highlight(index) {
    cards.forEach(function (card) {
      card.classList.toggle('is-active', card.dataset.index === String(index));
    });
  }

  function escapeHtml(s) {
    var div = document.createElement('div');
    div.textContent = s || '';
    return div.innerHTML;
  }
  function escapeAttr(s) {
    return String(s || '').replace(/"/g, '&quot;');
  }

  stores.forEach(function (store, index) {
    var coords = parseCoords(store.coords) || coordsFromMapsUrl(store.mapsUrl);
    if (coords) {
      addMarker(store, index, coords);
    } else {
      geocode(store.address).then(function (geocoded) {
        if (geocoded) addMarker(store, index, geocoded);
      });
    }
  });

  function activateCard(card) {
    var index = card.dataset.index;
    var marker = markers[index];
    if (!marker) return;
    highlight(index);
    map.flyTo(marker.getLatLng(), Math.max(map.getZoom(), 13), { duration: 0.6 });
    marker.openPopup();
    if (window.innerWidth < 960) {
      mapEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  cards.forEach(function (card) {
    card.addEventListener('click', function (e) {
      if (e.target.closest('a')) return;
      activateCard(card);
    });
    card.addEventListener('keydown', function (e) {
      if (e.target !== card) return;
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateCard(card);
      }
    });
  });
})();
